import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useLocation } from "react-router";
import { MContainer } from "../../element/Elemens";
import { Carousel } from "react-responsive-carousel";
import { useSelector, useDispatch } from "react-redux";
import { fetchProductOne } from "../../redux/actions/productActions";
import CurrencyFormat from "react-currency-format";
import { toast } from "react-toastify";
import ReactStars from "react-rating-stars-component";
import requests from "../../helpers/requests";
import queryString, { parse } from "query-string";
import success from "../../assets/images/success-icon.png";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import HTMLparseMM from "html-react-parser";
import "../../assets/scss/_product.scss";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "react-phone-input-2/lib/style.css";
import "react-toastify/dist/ReactToastify.css";
import ProductOrderForm from "../../component/Product/ProductOrderForm";
import { ProductOrderLoading } from "../../component/loading/product/ProductOrderLoading";
const URLUztez = `${process.env.REACT_APP_API_DOMAIN}`;

const ProductOrder = () => {
  const { productID } = useParams();
  const location = useLocation();
  const dispatch = useDispatch();

  const [orderSaved, setOrderSaved] = useState(false);
  const stream_user = queryString.parse(location.search);

  console.log(stream_user);

  const createOrder = (params) => {
    dispatch({ type: "create_order_start", payload: params });

    requests
      .createOrder(params)
      .then(({ data }) => {
        dispatch({ type: "create_order_success", payload: data });
        setOrderSaved(true);
      })
      .catch(({ response }) => {
        let message =
          (response && response.data.message) || "Mahsulot topilmadi";
        dispatch({ type: "create_order_error", payload: message });
        toast(message);
      });
  };

  useEffect(() => {
    dispatch(fetchProductOne(productID));
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [orderSaved]);

  const ratingChanged = (newRating) => {
    console.log(newRating);
  };

  const product = useSelector((state) => state.product.data);
  const { loadingOrder } = useSelector((state) => state.product);

  return (
    <>
      {loadingOrder ? (
        <ProductOrderLoading />
      ) : (
        <MContainer>
          {orderSaved ? (
            <div className="product__order__saved">
              <div className="product__order__saved__image__ramce">
                <img src={success} alt="Arizangiz qabul qilindi!" />
              </div>
              <h3>"Arizangiz qabul qilindi!"</h3>
              <p className="product__order__saved__text">
                Batafsil ma'lumot uchun operator yaqin vaqt ichida sizga aloqaga
                chiqadi. Iltimos, telefoningiz yoqilgan holda bo'lsin!
              </p>
            </div>
          ) : (
            <div className="product__order__page">
              <div className="product__order__page__title">
                <div className="product__order__page__product__title">
                  {product.title}
                </div>
                <div className="product__order__page__product__price">
                  <CurrencyFormat
                    value={
                      stream_user.delivery_included === "false"
                        ? product.price + 30000
                        : product.price
                    }
                    displayType={"text"}
                    thousandSeparator={true}
                  />{" "}
                  so'm
                </div>
              </div>
              <div className="product__order__page__title__icons">
                <ReactStars
                  count={5}
                  onChange={ratingChanged}
                  size={24}
                  activeColor="#103B7D"
                  value={4}
                />
                <span className="product__order__page__icon__text">
                  550 sharxlar
                </span>
              </div>
              <div className="product__order__page__row">
                <div className="product__order__page__corousel">
                  <Carousel
                    preventMovementUntilSwipeScrollTolerance={true}
                    autoPlay={true}
                    infiniteLoop={true}
                  >
                    {product.images &&
                      product.images.map((img, index) => (
                        <div className="product__order__page__corousel__image__ramce">
                          <img
                            src={URLUztez + `uploads/${img}`}
                            alt="Carousel"
                            key={index}
                          />
                        </div>
                      ))}
                  </Carousel>
                </div>
                <div className="product__order__page__user__info">
                  <h2>Buyurtma berish</h2>

                  {/* <div className="delivery_is_paid_style">
                    O‘zbekiston boylab yetkazib berish xizmati atigi 20,000
                    so‘mdan bo'shlab, "Maxsulotni" qo‘lingizga olganingizda
                    to‘lovni amalgi oshirasiz
                  </div> */}

                  {product.is_bonus ? (
                    <div className="product__order__bonus_style">
                      1 + 1 = 3 🎁 Yani ikkita olsangiz bittasi bonus 🎁
                    </div>
                  ) : (
                    ""
                  )}

                  <ProductOrderForm
                    productID={productID}
                    stream_user={stream_user}
                    onClickProductOrder={(data) => {
                      createOrder(data);
                    }}
                  />
                </div>
              </div>
              <div className="product__order__page__description">
                <div className="product__order__page__description__text">
                  <Tabs>
                    <TabList>
                      <Tab>Mahsulot haqida tavsif</Tab>
                    </TabList>

                    <TabPanel>
                      <p className="product__order__page__description__p">
                        {HTMLparseMM(product.description || "")}
                      </p>
                    </TabPanel>
                  </Tabs>
                </div>
              </div>
            </div>
          )}
        </MContainer>
      )}
    </>
  );
};

export default ProductOrder;
